import './FullPageSpinner.css';

export const FullPageSpinner = () => (
  <div className="full-page-spinner-overlay">
    <div className="full-page-spinner" />
  </div>
);
